export default function CustomerImportBatchErrorsTable({ errors }) {
  const rows = Array.isArray(errors) ? errors : [];
  if (rows.length === 0) {
    return <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm text-slate-500">Geen foutregels voor deze batch.</div>;
  }

  return (
    <div className="rounded-lg border border-rose-200 bg-rose-50 p-3">
      <h4 className="mb-2 text-sm font-semibold text-rose-800">Foutregels</h4>
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-xs text-rose-900">
          <thead>
            <tr className="border-b border-rose-200">
              <th className="px-2 py-2">Rij</th>
              <th className="px-2 py-2">Fout</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((item, index) => (
              <tr key={`${item.row}-${index}`} className="border-b border-rose-100 last:border-b-0">
                <td className="px-2 py-2">{item.row || "-"}</td>
                <td className="px-2 py-2">{item.reason || "Onbekende fout"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
